<template>
    <div>
        <div class="title">
            中国移动通信联合会
        </div>
        <el-carousel height="238px">
            <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                <img :src="item.xImage" alt="">
                <div class="text">{{ item.xName }}</div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    data() {
        return {
            bannerList: []
        }
    },
    mounted() {
        this.getBannerList()
    },
    methods: {
        getBannerList() {
            this.$api.get('banner/xList').then(res => {
                this.bannerList = res.data.list
            })
        }
    }

}
</script>

<style lang="scss" scoped>
//scss
.title {
    width: 100%;
    height: 26px;
    padding: 14px 0 13px;
    font-size: 18.72px;
    text-align: center;
    line-height: 26px;
    color: #000;
}
.el-carousel__item {
    img {
        width: 100%;
        height: 100%;
        position: relative;
    }
    .text {
        position: absolute;
        left: 0;
        bottom: 0;
        width: calc(100% - 44px);
        height: 23px;
        padding: 12px 22px 20px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6));
        font-size: 17px;
        color: #fff;
        z-index: 100;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
::v-deep .el-carousel__button {
    width: 5.2px;
    height: 5.2px;
    border-radius: 50%;
    opacity: 1;
}
::v-deep .is-active button {
    background: #243db3;
}
::v-deep .el-carousel__indicator--horizontal {
    padding: 7px 4px;
}
</style>
